import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routeMap';

Vue.use(VueRouter);

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
